<div style="display: flex; align-items: center; justify-content: end;"
     [ngClass]="{'has-node-selected' : isAnyNodeSelected && !isNodeProtected }">
  <div class="refresh-icon" style="padding: 8px 4px; cursor: pointer;" (click)="refreshNodeData()" matTooltip="Refresh folders">
    <span class="fa-light fa-refresh" style="padding-right: 10px;"></span>
  </div>
  <div *inRole="[roles.EditFeatureSet]" class="refresh-icon" style="padding: 8px 4px; cursor: pointer; margin-right: auto" (click)="importFolders()" matTooltip="Import Folders">
    <span class="fa-light fa-arrow-down-to-line" style="padding-right: 10px;"></span>
  </div>
  <div *inRole="[roles.EditFeatureSet]" class="rename-icon" style="padding: 8px 4px;" (click)="!isNodeProtected && editFolder($event)" matTooltip="Rename selected folder">
    <span class="fa-light fa-pen-field" style="padding-right: 10px;"></span>
  </div>
  <div *inRole="[roles.EditFeatureSet]" class="delete-icon" style="padding: 8px 4px;" (click)="!isNodeProtected && removeFolder($event)" matTooltip="Delete selected folder">
    <span class="fa-light fa-trash" style="padding-right: 10px;"></span>
  </div>
</div>
<mat-tree [dataSource]="dataSource" [treeControl]="treeControl"
          style="height: 340px; overflow: auto;">
  <mat-tree-node *matTreeNodeDef="let node" [matTreeNodePadding]="node.level" matTreeNodePaddingIndent="10"
                 style="font-size: 12px; min-height: 20px;"
                 [ngClass]="{'node-selected': node.selected }">
    <button mat-icon-button disabled>
      <span class="fa-light fa-folder-closed" style="font-size: 12px;"></span>
    </button>
    <div style="cursor: pointer;" (click)="folderClick(node)">{{node.displayName}}</div>
    <span *inRole="[roles.EditFeatureSet]" class="fa-light fa-plus add-icon" style="padding-left: 10px;" (click)="addFolder($event, node)"></span>
  </mat-tree-node>

  <mat-tree-node *matTreeNodeDef="let node; when hasChild" [matTreeNodePadding]="node.level"
                 matTreeNodePaddingIndent="10" style="font-size: 12px; min-height: 20px;"
                 [ngClass]="{'node-selected': node.selected }" matTreeNodeToggle>
    <button mat-icon-button>
      <span class="fa-regular"
            [ngClass]="{'fa-folder-open': treeControl.isExpanded(node), 'fa-folder-closed': !treeControl.isExpanded(node)}"
            style="font-size: 12px;"></span>
    </button>
    <div style="cursor: pointer;" (click)="folderClick(node)">{{node.displayName}}</div>
    <span *inRole="[roles.EditFeatureSet]">
          <span *ngIf="!node.isLoading" class="fa-light fa-plus add-icon" style="padding-left: 10px;"
                 (click)="addFolder($event, node)"></span>
    </span>

    <span *ngIf="node.isLoading" style="padding-left: 10px;">
          <mat-spinner diameter="15" color="primary"></mat-spinner>
    </span>
  </mat-tree-node>
</mat-tree>
